export interface UpdateState {
  isDownloading: boolean;
  isUpdateAvailable: boolean;
  currentVersion: string | null;
  latestVersion: string | null;
  lastChecked: Date | null;
  error: string | null;
}

export interface VersionInfo {
  hash: string;
  appData?: Record<string, unknown>;
}

export interface UpdateCheckResult {
  updateAvailable: boolean;
  currentVersion?: VersionInfo;
  latestVersion?: VersionInfo;
  timestamp: Date;
}

export type VersionEvent =
  | { type: 'VERSION_DETECTED'; version: VersionInfo }
  | {
      type: 'VERSION_READY';
      currentVersion: VersionInfo;
      latestVersion: VersionInfo;
    }
  | {
      type: 'VERSION_INSTALLATION_FAILED';
      version: VersionInfo;
      error: string;
    };

export const APP_UPDATE_RELOAD_PATH = 'update';

export const BACKGROUND_RELOAD_THRESHOLD_MS = 30 * 60 * 1000;

export const UNRECOVERABLE_RELOAD_DELAY_MS = 3000;

export const UPDATE_CHECK_TIMEOUT_MS = 10 * 1000;

export const RETURN_UPDATE_CHECK_TIMEOUT_MS = 60 * 1000;

export const MIN_RETURN_CHECK_INTERVAL_MS = 60 * 1000;

export const ACTIVATE_UPDATE_TIMEOUT_MS = 10 * 1000;

export const PENDING_REQUESTS_TIMEOUT_MS = 5 * 1000;
